'use client';

import { FC, ChangeEvent, useState, useRef } from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';
import styles from './Input.module.scss';

interface DOBInputProps {
  label?: string;
  id: string;
  error?: FieldError;
  register: UseFormRegisterReturn;
  placeholder: string;
  currentValue: string;
}

const formatDOB = (value: string) => {
  const cleaned = value.replace(/\D/g, '');
  if (cleaned.length <= 2) return cleaned;
  if (cleaned.length <= 4) return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
  return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4, 8)}`;
};

const unformatDOB = (formattedValue: string) =>
  formattedValue.replace(/\D/g, '');

const DOBInput: FC<DOBInputProps> = ({
  label,
  id,
  error,
  register,
  placeholder,
  currentValue,
}) => {
  const [value, setValue] = useState(
    formatDOB(unformatDOB(currentValue || ''))
  );
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const input = e.target;
    const rawValue = unformatDOB(input.value);
    const cursorPosition = input.selectionStart || 0;

    const formattedValue = formatDOB(rawValue);
    const addedChars = formattedValue.length - input.value.length;
    e.target.value = formattedValue;

    setValue(formattedValue);

    setTimeout(() => {
      if (inputRef.current) {
        const newCursorPosition = cursorPosition + addedChars;
        inputRef.current.setSelectionRange(
          newCursorPosition,
          newCursorPosition
        );
      }
    });

    if (register.onChange) register.onChange(e);
  };

  return (
    <div className={`${styles.fieldWrapper} ${error ? styles.errorField : ''}`}>
      {label && (
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
      )}
      <input
        className={`${styles.input} ${styles.dobInput}`}
        id={id}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        maxLength={10}
        name={register.name}
        ref={(e) => {
          inputRef.current = e;
          register.ref(e);
        }}
      />
      {error && <p className={styles.error}>{error.message}</p>}
    </div>
  );
};

export default DOBInput;
